export enum PresetSettings {
  ACCORDION_TOP_CATEGORIES,
  ACCORDION_SIDE_CATEGORIES,
  NUMERIC_TOP_CATEGORIES,
  NUMERIC_SIDE_CATEGORIES,
  LIST_TOP_CATEGORIES,
  LIST_SIDE_CATEGORIES,
  LINES_TOP_CATEGORIES,
  LINES_SIDE_CATEGORIES,
}
